import { useEffect, useState } from "react";

import { buildEditPostInitialState } from "./editPostPayloadBuilder";

export default function useEditPostFormState(post) {
  const [formState, setFormState] = useState(() =>
    buildEditPostInitialState(post)
  );

  useEffect(() => {
    setFormState(buildEditPostInitialState(post));
  }, [post]);

  const setCaption = (value) => {
    setFormState((current) => ({
      ...current,
      caption: value,
    }));
  };

  const setCatchField = (fieldName, value) => {
    setFormState((current) => ({
      ...current,
      catch: {
        ...current.catch,
        [fieldName]: value,
      },
    }));
  };

  return {
    formState,
    setCaption,
    setCatchField,
  };
}
